module.exports = __webpack_public_path__ + "public/images/netw-soon-tagline.5bd45b73c82379239a1658c71b404606.png";